import React, { useEffect, useState } from 'react';
import { Container } from 'react-bootstrap';
import styled from 'styled-components';
import Slider from 'react-slick';
import { UilArrowCircleLeft } from '@iconscout/react-unicons';
import { UilArrowCircleRight } from '@iconscout/react-unicons';
import { useTranslation } from 'react-i18next';

const StyledSlider = styled(Slider)`
  margin-bottom: 50px;
  > .slick-dots li {
    width: 8px;
    height: 8px;
    padding: 0px;
    background: #C4C4C4;
    border-radius: 4px;
  }

  > .slick-dots li button:before {
    display: none;
  }

  > .slick-dots li.slick-active {
    background: #686766;
  }

  > svg {
    @media only screen and (max-width: 767px) {
      display: none !important;
    }
  }
`;

const Card = styled.div`
  padding-top: 26px;
  padding-bottom: 25px;
  text-align: left;
  span {
    font-weight: 700;
  }
  .item-image {
    width: 130px;
    margin: 0 auto 27px;
  }
  ul {
    margin: 40px auto 0;
    width: 167px;
  }
  ul:nth-of-type(1) {
    list-style-type: disc;
  }
`;

export const SliderOfferAdvantages = (props) => {
  const {t} = useTranslation('global');
  const [screenWidth, setScreenWidth] = useState(window.innerWidth);
  const Offers = [
  {
    id: 0,
    image: "https://firebasestorage.googleapis.com/v0/b/covid19-cc1fe.appspot.com/o/axiona%2Fmedicos%2Fslide-offer-image-1.png?alt=media&token=9bfdef4e-690c-44cc-97db-eb273ded346e",
    textBold: t('doctors.why-axiona.slides-offer.0.bold'),
    textRegular: t('doctors.why-axiona.slides-offer.0.regular'),
  },
  {
    id: 1,
    image: "https://firebasestorage.googleapis.com/v0/b/covid19-cc1fe.appspot.com/o/axiona%2Fmedicos%2Fslide-offer-image-2.png?alt=media&token=6c5ec26b-a321-4c19-b7e1-111a55edcc7d",
    textBold: t('doctors.why-axiona.slides-offer.1.bold'),
    textRegular: t('doctors.why-axiona.slides-offer.1.regular'),
  },
  {
    id: 2,
    image: "https://firebasestorage.googleapis.com/v0/b/covid19-cc1fe.appspot.com/o/axiona%2Fmedicos%2Fslide-offer-image-3.png?alt=media&token=350ab2c6-725d-49bf-9cd7-b763fcf1df14",
    textBold: t('doctors.why-axiona.slides-offer.2.bold'),
    textRegular: t('doctors.why-axiona.slides-offer.2.regular'),
  },
  {
    id: 3,
    image: "https://firebasestorage.googleapis.com/v0/b/covid19-cc1fe.appspot.com/o/axiona%2Fmedicos%2Fslide-offer-image-4.png?alt=media&token=e4ef79ff-0ea8-44f1-a9d3-1a3f8996d1fb",
    textBold: t('doctors.why-axiona.slides-offer.3.bold'),
    textRegular: t('doctors.why-axiona.slides-offer.3.regular'),
  },
  {
    id: 4,
    image: "https://firebasestorage.googleapis.com/v0/b/covid19-cc1fe.appspot.com/o/axiona%2Fmedicos%2Fslide-process-image-5.png?alt=media&token=f8cd107b-f373-48c3-a892-8ba55e1642f1",
    textBold: "",
    textRegular: t('doctors.why-axiona.slides-offer.4.regular'),
  },
  {
    id: 5,
    image: "https://firebasestorage.googleapis.com/v0/b/covid19-cc1fe.appspot.com/o/axiona%2Fmedicos%2Fslide-offer-image-6.png?alt=media&token=6bfe8002-cbf9-4d83-b90c-d0ae89af9742",
    textBold: t('doctors.why-axiona.slides-offer.5.bold'),
    textRegular: t('doctors.why-axiona.slides-offer.5.regular'),
  },
  ];

  const Advantages = [
    {
      id: 0,
      image: "https://firebasestorage.googleapis.com/v0/b/covid19-cc1fe.appspot.com/o/axiona%2Fmedicos%2Fslide-advantage-image-1.png?alt=media&token=1c72a24f-d151-48b8-af74-25c9492fb70b",
      textBold: t('doctors.why-axiona.slides-advan.0.bold'),
      textRegular: t('doctors.why-axiona.slides-advan.0.regular'),
    },
    {
      id: 1,
      image: "https://firebasestorage.googleapis.com/v0/b/covid19-cc1fe.appspot.com/o/axiona%2Fmedicos%2Fslide-advantage-image-2.png?alt=media&token=63b59b9a-1741-4fa2-974e-9f31449172b5",
      textBold: t('doctors.why-axiona.slides-advan.1.bold'),
      textRegular: t('doctors.why-axiona.slides-advan.1.regular'),
    },
    {
      id: 2,
      image: "https://firebasestorage.googleapis.com/v0/b/covid19-cc1fe.appspot.com/o/axiona%2Fmedicos%2Fslide-advantage-image-3.png?alt=media&token=05dc61f8-1088-4d67-9923-eedd41fd6e0a",
      textBold: t('doctors.why-axiona.slides-advan.2.bold'),
      textRegular: t('doctors.why-axiona.slides-advan.2.regular'),
    },
    {
      id: 3,
      image: "https://firebasestorage.googleapis.com/v0/b/covid19-cc1fe.appspot.com/o/axiona%2Fmedicos%2Fslide-process-image-3.png?alt=media&token=981eee6d-93ae-4f16-9945-424deecca29f",
      textBold: t('doctors.why-axiona.slides-advan.3.bold'),
      textRegular: t('doctors.why-axiona.slides-advan.3.regular'),
    },
    {
      id: 4,
      image: "https://firebasestorage.googleapis.com/v0/b/covid19-cc1fe.appspot.com/o/axiona%2Fmedicos%2Fslide-advantage-image-5.png?alt=media&token=a279ca83-9a45-4859-bdb6-d298519b2c84",
      textBold: t('doctors.why-axiona.slides-advan.4.bold'),
      textRegular: t('doctors.why-axiona.slides-advan.4.regular'),
    },
    {
      id: 5,
      image: "https://firebasestorage.googleapis.com/v0/b/covid19-cc1fe.appspot.com/o/axiona%2Fmedicos%2Fslide-offer-image-6.png?alt=media&token=6bfe8002-cbf9-4d83-b90c-d0ae89af9742",
      textBold: t('doctors.why-axiona.slides-advan.5.bold'),
      textRegular: t('doctors.why-axiona.slides-advan.5.regular'),
    },
  ];

  function handleWindowSizeChange() {
    setScreenWidth(window.innerWidth);
  }
  useEffect(() => {
    window.addEventListener('resize', handleWindowSizeChange);
    return () => {
      window.removeEventListener('resize', handleWindowSizeChange);
    };
  }, []);

  function PrevArrow(props) {
    const { className, style, onClick } = props;
    return (
      <UilArrowCircleLeft
        className={className}
        style={{ ...style, display: 'block', color: '#00AD90' }}
        onClick={onClick}
      />
    );
  }
  function NextArrow(props) {
    const { className, style, onClick } = props;
    return (
      <UilArrowCircleRight
        className={className}
        style={{ ...style, display: 'block', color: '#00AD90' }}
        onClick={onClick}
      />
    );
  }

  return (
    <StyledSlider
      dots={true}
      infinite={true}
      slidesToShow={
        screenWidth > 991
          ? 2
          : screenWidth > 767
          ? 2
          : 1
      }
      slidesToScroll={
        screenWidth > 991
          ? 2
          : screenWidth > 767
          ? 2
          : 1
      }
      autoplay={true}
      autoplaySpeed={4000}
      cssEase={'linear'}
      speed={600}
    >
      {(props.cat === 0 ? Offers : Advantages ).map((item, index) => (
        <Card>
          <img alt={`imagen-${index}`} src={item.image} className="item-image" />
          <ul>
            <li><span>{item.textBold}</span>{item.textRegular}</li>
          </ul>
        </Card>
      ))}
    </StyledSlider>
  );
};
